import union from 'lodash/union'

export interface ProductsDeptSubClazz {
  dept: number[]
  deptClazz: string[]
  deptClazzSubClazz: string[]
  vendors: number[]
  merchTypes: number[]
  itemTypes: number[]
  countryOfOrigins: string[]
  planIds: number[]
  colorFamilyIds: number[]
  patternFamilyIds: number[]
}

export const mergeProductDeptSubClazz = (
  a: ProductsDeptSubClazz,
  b: ProductsDeptSubClazz,
): ProductsDeptSubClazz => ({
  ...a,
  dept: union(a.dept, b.dept),
  deptClazz: union(a.deptClazz, b.deptClazz),
  deptClazzSubClazz: union(a.deptClazzSubClazz, b.deptClazzSubClazz),
  vendors: union(a.vendors, b.vendors),
  merchTypes: union(a.merchTypes, b.merchTypes),
  itemTypes: union(a.itemTypes, b.itemTypes),
  countryOfOrigins: union(a.countryOfOrigins, b.countryOfOrigins),
  planIds: union(a.planIds, b.planIds),
  colorFamilyIds: union(a.colorFamilyIds, b.colorFamilyIds),
  patternFamilyIds: union(a.patternFamilyIds, b.patternFamilyIds),
})
